import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import PageTitle from "./PageTitleCompoent";
import "../css/AddPackage.css";
import api from "../api"; // centralized axios instance

export default function AddDoctorAppointmentPackage() {
  const navigate = useNavigate();

  const [packageName, setPackageName] = useState("");
  const [duration, setDuration] = useState("");
  const [amount, setAmount] = useState("");
  const [subscribedAmount, setSubscribedAmount] = useState("");
  const [appointmentType, setAppointmentType] = useState(""); // home/clinical/video
  const [promoTag, setPromoTag] = useState("");
  const [services, setServices] = useState([]);
  const [newService, setNewService] = useState("");
  const [showInput, setShowInput] = useState(false);

  const tagMapping = {
    Popular: "popular",
    "Great Deals": "great_deals",
    "Steal Deals": "steal_deals",
  };

  const handleSave = async () => {
    if (!packageName.trim()) {
      alert("Please enter package name");
      return;
    }
    if (!appointmentType) {
      alert("Please select appointment type");
      return;
    }
    if (!amount.trim() || !subscribedAmount.trim()) {
      alert("Please enter both price and subscribed offer price");
      return;
    }

    const newPackage = {
      package_name: packageName.trim(),
      duration: duration.trim(),
      package_amount: Number(amount),
      subscribed_user_offer_amount: Number(subscribedAmount),
      package_type: appointmentType, // only this type will be saved
      services: services.join(","),
      tags: tagMapping[promoTag] || "",
    };

    console.log("Saving package:", newPackage);

    try {
      const res = await api.post("/doctor-appointment-packages/", newPackage);
      console.log("API Response:", res.data);

      alert(`Package for ${appointmentType.replace("_", " ")} saved successfully!`);
      navigate(-1); // go back after saving
    } catch (error) {
      console.error("Error saving package:", error);
      alert("Failed to save package. Please check inputs.");
    }
  };

  const handleAddServiceClick = () => {
    setShowInput(true);
  };

  const handleInputChange = (e) => {
    setNewService(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      addNewService();
    }
  };

  const handleCloseInput = () => {
    addNewService();
  };

  const addNewService = () => {
    if (newService.trim()) {
      setServices((prev) => [...prev, newService.trim()]);
      setNewService("");
    }
    setShowInput(false);
  };

  const handleDeleteService = (index) => {
    setServices((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="Add-package-container">
      <Sidebar />
      <div className="Add-package-main">
        <Header />
        <div className="Add-package-content">
          <PageTitle title="Add Doctor Appointment Package" onBack={() => navigate(-1)} />

          <div className="Add-package-grid">
            {/* Package Name & Duration */}
            <div className="Add-package-form-row">
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Package Name</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="text"
                  value={packageName}
                  onChange={(e) => setPackageName(e.target.value)}
                  placeholder="Enter Package Name..."
                  style={{ width: "65%" }}
                />
              </div>
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Duration</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="text"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                  placeholder="Enter Duration..."
                  style={{ width: "65%" }}
                />
              </div>
            </div>

            {/* Appointment Type & Tags */}
            <div className="Add-package-form-row">
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Appointment Type</h3>
                </label>
                <select
                  className="Add-package-inputbox"
                  value={appointmentType}
                  onChange={(e) => setAppointmentType(e.target.value)}
                  style={{ width: "65%" }}
                >
                  <option value="">-- Select Appointment Type --</option>
                  <option value="home_visit">Home Visit</option>
                  <option value="clinical_visit">Clinical Visit</option>
                  <option value="video_call">Video Call</option>
                </select>
              </div>

              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Tags</h3>
                </label>
                <div className="Add-package-tags-buttons">
                  {["Popular", "Great Deals", "Steal Deals"].map((tagOption) => (
                    <button
                      key={tagOption}
                      className={`Add-package-tag-button ${
                        promoTag === tagOption ? `${tagMapping[tagOption]}_selected` : ""
                      }`}
                      onClick={() => setPromoTag(tagOption)}
                      type="button"
                    >
                      {tagOption}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Amount & Subscribed Amount */}
            <div className="Add-package-form-row">
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Package Amount</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Enter Amount..."
                  style={{ width: "65%" }}
                />
              </div>
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Subscribed User Offer Amount</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="number"
                  value={subscribedAmount}
                  onChange={(e) => setSubscribedAmount(e.target.value)}
                  placeholder="Enter Offer Amount..."
                  style={{ width: "65%" }}
                />
              </div>
            </div>

            {/* Services */}
            <div className="Add-package-form-group1">
              <label>
                <h3 className="Add-package-text2">Services</h3>
              </label>
              <div className="Add-package-service-box">
                <ul className="service-list">
                  {services.map((service, index) => (
                    <li key={index} className="service-item">
                      <span
                        className="service-hyphen"
                        onClick={() => handleDeleteService(index)}
                        style={{ cursor: "pointer", color: "red", marginRight: 8 }}
                      >
                        −
                      </span>
                      {service}
                    </li>
                  ))}
                </ul>
                {showInput ? (
                  <input
                    type="text"
                    value={newService}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyPress}
                    onBlur={handleCloseInput}
                    autoFocus
                    className="service-input"
                  />
                ) : (
                  <button
                    className="add-service-btn"
                    onClick={handleAddServiceClick}
                    type="button"
                  >
                    +
                  </button>
                )}
              </div>
            </div>

            {/* Save Button */}
            <div className="Add-package-button-wrapper">
              <button className="Add-package-save-button" onClick={handleSave} type="button">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
